// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const CriticalIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="CriticalIcon" ref={forwardedRef} {...props}>
      <path d="M9.25 6.237h1.5v4.5h-1.5z" />
      <path d="M11 12.737a1 1 0 1 0-2 0 1 1 0 0 0 2 0" />
      <path d="M9.293 1.513a1 1 0 0 1 1.414 0l7.78 7.78a1 1 0 0 1 0 1.414l-7.78 7.78a1 1 0 0 1-1.414 0l-7.78-7.78a1 1 0 0 1 0-1.414zM17.073 10 10 2.927 2.927 10 10 17.073z" />
    </SvgIcon>
  );
});

/**
 * Use when something needs attention
 * @public
 */
export const CriticalIcon = /* @__PURE__ */ Object.assign(
  CriticalIconComponent,
  { displayName: 'CriticalIcon' },
);
